import Grid from "../Grid/Grid";
import SearchAndFilter from "../SearchAndFilter/SearchAndFilter";
import Card from '../ImageCard/ImageCard';
import styles from '../ProjectsContent/ProjectsContent.module.css';
import logo from '../../assets/les-logo.png'

const filterOptions = [
    { value: 'filtro1', label: 'Pesquisa' },
    { value: 'filtro2', label: 'Desenvolvimento e tecnologia' },
    { value: 'filtro3', label: 'Ver Todos' }
];

export default function ProjectsContent() {
    const elements = Array.from({ length: 100 }, (v, k) => <Card key={k} imageUrl={logo} seeMore="Ver Mais" title='Título do Projeto' description='Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tincidunt ultricies nec lacus luctus faucibus. Morbi morbiadipiscing elit.' />)

    return (
        <div className={styles['container']} data-testid="projects-content">
            <div className={styles['title']}>Projetos</div>

            <SearchAndFilter filterList={filterOptions} />

            <Grid items={elements} />
        </div>
    );
}